


















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Global } from '@/store';
import { getTimeRemainingLabel } from '@/modules/ScheduleUtils';

@Component({})
class ScheduleExpirationBadge extends Vue {
  @Global.State('lang') lang;

  @Prop({ type: Object, required: true }) expiration;

  get is_highlighted() {
    return this.expiration.status === 'expired' || this.expiration.status === 'expiring_soon';
  }

  get label() {
    return getTimeRemainingLabel(this.expiration);
  }
}

export default ScheduleExpirationBadge;
